<template>
	<div>
		<el-upload :action="hostUrl + '/file/upload'" :on-success="uploadSuccess" list-type="picture-card" :data="uploadData" :on-preview="handlePictureCardPreview"  :show-file-list="showFileList" :file-list="fileList" :on-remove="handleRemove">
			<i class="el-icon-plus"></i>
		</el-upload>
		<el-dialog :visible.sync="dialogVisible" >
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				hostUrl: config.hostUrl,
				dialogImageUrl: '',
				dialogVisible: false,
				fileList: [],
				iconPathList: [], //插入图片集合
				iconPath: '', //插入单张,
			}
		},
		props: {
			uploadData: {
				type: Object,
				require: true
			},
			uploadType: {
				type: String
			},
			showFileList: {
				type: Boolean,
				default: true
			},
			businessId: {
				type: String
			},
			defaultFilePath: {
				type: String
			}
		},
		mounted() {
			var _this = this;
			_this.$nextTick(function() {
				if ('Array' == _this.uploadType) {
					_this.findByBusinessIdAndType();
				} else if (_this.defaultFilePath) {
					_this.loadIconPath(_this.defaultFilePath);
				}
			})
		},
		methods: {
			getIconPath() {
				var _this = this;
				if ('Array' == _this.uploadType) {
					return _this.iconPathList;
				} else {
					return _this.iconPath;
				}
			},
			findByBusinessIdAndType() {
				var _this = this;
				if (_this.businessId) {
					_this.$common.my_ajax({
						url: 'attach/findByBusinessIdAndType',
						data: {
							type: _this.uploadData.fileNamePre,
							businessId: _this.businessId,
						},
						success: function(response) {
							var _item = response.items || [];
							_this.fileList = [];
							_this.iconPathList = [];
							for (var i in _item) {
								var _iconPath = {
									'url': config.dynamicResourcePath + _item[i].path,
									'type': _item[i].type
								}
								_this.fileList.push(_iconPath);
								_this.iconPathList.push(_item[i]);
							}
						}
					});
				}
			},
			uploadSuccess(res, file) {
				var _this = this;
				if ('Array' === _this.uploadType) {
					var _iconPath = {
						'url': config.dynamicResourcePath + res.msg
					}
					_this.fileList.push(_iconPath);
					_this.iconPathList.push({
						'path': res.msg,
						'type': _this.uploadData.fileNamePre
					});
				} else {
					_this.loadIconPath(res.msg);
				}
			},
			loadIconPath(_path) {
				var _this = this;
				if (_path) {
					_this.fileList = [];
					var _iconPath = {
						'url': config.dynamicResourcePath + _path,
						'type': _this.uploadData.fileNamePre
					}
					if (_path.startsWith("http")) {
						Object.assign(_iconPath,{'url':_path});
					}
					_this.fileList[0] = _iconPath;
					_this.iconPath = _path;
				}
			},
			handleRemove(file, fileList) {
				var _this = this;
				var _iconPath = null;
				if ('Array' === _this.uploadType) {
					_this.fileList = fileList;
					var pathArray = file.url.split(config.dynamicResourcePath);
					for (var i in _this.iconPathList) {
						if (pathArray[1] == (_this.iconPathList[i].path + '')) {
							if (i == 0) {
								_this.iconPathList.splice(0, 1);
							} else {
								_this.iconPathList.splice(i - 1, i);
							}
						}
					}
				} else {
					_this.fileList.pop();
					_this.iconPath =null;
				}
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
		},
		watch: {
			'businessId': function() {
				this.findByBusinessIdAndType();
			},
			defaultFilePath: function() {
				this.loadIconPath(this.defaultFilePath);
			}
		}
	}
</script>
